/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export type RewardsClaimed = {
  market: Address;
  claimer: Address;
  burnedAmount: bigint;
  rewardAmount: bigint;
  totalBurned: bigint;
};

export type RewardsClaimedArgs = {
  market: Address;
  claimer: Address;
  burnedAmount: number | bigint;
  rewardAmount: number | bigint;
  totalBurned: number | bigint;
};

export function getRewardsClaimedEncoder(): FixedSizeEncoder<RewardsClaimedArgs> {
  return getStructEncoder([
    ['market', getAddressEncoder()],
    ['claimer', getAddressEncoder()],
    ['burnedAmount', getU64Encoder()],
    ['rewardAmount', getU64Encoder()],
    ['totalBurned', getU64Encoder()],
  ]);
}

export function getRewardsClaimedDecoder(): FixedSizeDecoder<RewardsClaimed> {
  return getStructDecoder([
    ['market', getAddressDecoder()],
    ['claimer', getAddressDecoder()],
    ['burnedAmount', getU64Decoder()],
    ['rewardAmount', getU64Decoder()],
    ['totalBurned', getU64Decoder()],
  ]);
}

export function getRewardsClaimedCodec(): FixedSizeCodec<
  RewardsClaimedArgs,
  RewardsClaimed
> {
  return combineCodec(getRewardsClaimedEncoder(), getRewardsClaimedDecoder());
}
